<template>
  <IonApp class="global-app">
    <template v-if="isAuthLoading">
      <EmnLoader />
    </template>

    <template v-else-if="!isAuthenticated">
      <LoginPage />
    </template>

    <template v-else>
      <NavigationLayout />
      <ContentLayout>
        <IonRouterOutlet id="main-content" :key="$route.fullPath" />
      </ContentLayout>
    </template>
  </IonApp>
</template>

<script setup lang="ts">
import { provide, onMounted, ref } from 'vue';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { useTheming, type ThemingContext } from '@/common/composables/useTheming';
import { useRoute } from 'vue-router';
import { useUser } from '@/common/composables/useUser';
import { authService } from '@/features/common/auth/services/authService';

import NavigationLayout from '@/layouts/navigation-layout/NavigationLayout.vue';
import LoginPage from '@/features/common/auth/views/LoginPage.vue';
import ContentLayout from '@/layouts/ContentLayout.vue';
import EmnLoader from '@/common/components/loader/EmnLoader.vue';

const theming = useTheming();
const $route = useRoute();
const { isAuthenticated } = useUser();
const isAuthLoading = ref(true);

provide<ThemingContext>('theme', theming);

onMounted(async () => {
  await authService.waitForInitialization();
  isAuthLoading.value = false;
  // Remove the HTML splash screen
  document.getElementById('app-splash')?.remove();
});
// Provide theming context for legacy components that use inject('theme')
</script>

<style scoped>
.global-app {
  background: var(--ion-background-layout);
}
</style>
